
export default function MapSiembraco() {
  let mapStore;

  initMapSiembraco();

  function initMapSiembraco() {
    mapStore = new google.maps.Map(document.getElementById("mapa-result-siembraco"), {
      center: { lat: 4.6097548, lng: -74.1655719 },
      zoom: 7,
      mapTypeId: "roadmap",
    });
    resultData();
  }

  function resultData() {
    let data = document.querySelectorAll(".data-result")
    eqfeed_callback(data);
  }

  function eqfeed_callback(features) {
    const image = "https://www.co.siembraco.com/sites/default/files/2022-03/icon-location-green.png";

    for (let i = 0; i < features.length; i++) {
      let dataCleanLat = features[i].attributes[0].value;
      let info = features[i].innerHTML;
      let dataClean = dataCleanLat.replace(/[:_"lng""lat"{} ]/g, '');
      
      const coords = dataClean.split(',');
      const latLng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));

      const infowindow = new google.maps.InfoWindow({
        content: info,
      });
      const marker = new google.maps.Marker({
        position: latLng,
        map: mapStore,
        animation: google.maps.Animation.DROP,
        icon: image,
      });
      marker.addListener("click", () => {
        infowindow.open({
          anchor: marker,
          map: mapStore,
          shouldFocus: false,
        });
      });
    }
  };
}